<template>
    <div class="mobile-sidebar" :class="{open: openSendwich}" v-if="setup != null">
        <div class="mobile-sidebar-head">
            <div class="mobile-lang">
                <ul class="lang-link-select">
                    <li class="body-lang-ru" :class="{'active' : globalLang == ''}"><a href="#" @click.prevent="setLocale('')">Рус</a></li>
                    <li class="body-lang-kz" :class="{'active' : globalLang == 'kz/'}"><a href="#" @click.prevent="setLocale('kz/')">Қаз</a></li>
                    <li class="body-lang-en" :class="{'active' : globalLang == 'en/'}"><a href="#" @click.prevent="setLocale('en/')">Eng</a></li>
                </ul>
            </div>
            <div class="link-auth">
                <a :href="URLrocketLC + '/?lang=' + globalLang" @click.prevent="linkToCabinet" target="_blank">
                    <!-- <svgIcon name="user-icon" class="icon-user"/> -->
                    <svgIcon name="login-new" class="icon-user"/>
                    <span>Личный кабинет</span>
                </a>
            </div>
        </div>
        <!-- <navMain></navMain> -->
        <div class="nav-mobile-list">
            <ul>
                <li v-for="(item, index) in setup.header_nav_mobile" :key="index">
                    <router-link :to="item.href" @click.native="startLoader">
                        <div class="item-icon">
                            <img :src="item.icon" alt="">
                        </div>
                        <div class="item-desc">
                            <span v-html="item.name"></span>
                        </div>
                        <svgIcon name="arrow-go-right"/>
                    </router-link>
                </li>
            </ul>
        </div>
        <div class="nav-mobile-classic">
            <navMain></navMain>
        </div>
    </div>
</template>

<script>
    import navMain from '@/components/nav-main/mobile-nav-main.vue'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    import SlideUpDown from 'vue-slide-up-down'
    import {mapGetters} from 'vuex'
    export default {
        name: 'mobileSidebar',
        data () {
            return {
                globalLang: window.GlobalLang, 
            }
        },
        components: {
            navMain,
            SlideUpDown,
            svgIcon,
        },
        computed: mapGetters({
            setup: 'loadPageSetUp',
            openSendwich: 'loadOpenSendwich',
            currentCityArr: 'loadCurrentCityArr',
            URLrocketLC: 'loadUrlRocketLC',
        }),
        methods: {
            startLoader() {
                this.$parent.$refs.topProgress.start();
            },
            setLocale(lang) {
                localStorage.setItem('language', lang);
                document.location.reload(true);
            },
            closeMobileMenu(data) {
                this.$store.commit('Open_Sendwich', data);
                document.getElementsByTagName('body')[0].classList.toggle('overlay-open');
            },
            linkToCabinet() {
                // console.log(this.window.rockeLC, 'asdsadasda')
                var exist = localStorage.getItem('favorite_flats');
                exist = exist ? exist.split(',') : [];
                var url = this.URLrocketLC + '/?lang=' + this.langVAR;
                var favoriteUrl;
                if (exist.length > 0) {
                    favoriteUrl = '&favoritesFlats=' + exist.join(',');
                    console.log(exist, favoriteUrl);
                    window.open(
                        url + favoriteUrl,
                        '_blank'
                    );
                } else {
                    window.open(
                        url,
                        '_blank'
                    );
                }
            },
            // disableOverlay() {
            //     this.$store.commit('Open_Sendwich', false);
            //     document.getElementsByTagName('body')[0].classList.remove('overlay-open');
            // }
        },
        created() {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/respond/mobile-sidebar/mobile-sidebar.scss';
    // @import '@/styles/components/nav-main/respond-nav-main.scss';
</style>